import Container from "@mui/material/Container";
import Link from "@mui/material/Link";
import Typography from "@mui/material/Typography";
import { Link as RouterLink } from "react-router";

type Props = {
  title: string;
};

/**
 * Stands in for the Privacy Policy and the Terms of Use until their text is written.
 *
 * The footer and the cookie banner link to these addresses, and both used to fall
 * through to the 404. A consent banner whose policy link is a 404 cannot ship; one whose link
 * says the policy is coming can. The wording is legal copy and lands separately (#5168).
 *
 * Reachable signed in or out: it sits outside the session-guarded routes.
 */
export default function LegalDocumentPage(props: Readonly<Props>) {
  return (
    <Container maxWidth="md" sx={{ py: 4 }}>
      <Typography variant="h4" component="h1" gutterBottom>
        {props.title}
      </Typography>
      <Typography variant="body1" sx={{ mb: 2 }}>
        This page is being written and will be published here.
      </Typography>
      <Typography variant="body1" sx={{ mb: 2 }}>
        Until then, send any question about it to{" "}
        <Link href="mailto:contactus@attorneyhub.com">contactus@attorneyhub.com</Link>.
      </Typography>
      <Link component={RouterLink} to="/">
        Return to Attorney Hub
      </Link>
    </Container>
  );
}
